import { TextArea } from '@onwardtravelsolutions/package-react/Components';
import { ValidationStatus } from '@onwardtravelsolutions/package-react/Enums';
import { useFieldFocus } from '@onwardtravelsolutions/package-react/Hooks';
import { Notice } from '@onwardtravelsolutions/package-react/Types';
import React from 'react';
import { getValidation } from '../../Utilities/validation';
import Field from './Field';
import FieldValidation from './FieldValidation';

type TextFieldProps = {
    id: string;
    label?: string;
    className?: string;
    children?: React.ReactNode;
    setValue?: (value: any) => void;
    onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
    status?: ValidationStatus;
    notices?: Notice[];
    isDirty?: boolean;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export default function TextField({
    id,
    children,
    status,
    notices = [],
    label = null,
    className = null,
    onChange = null,
    setValue = null,
    isDirty = false,
    ...rest
}: TextFieldProps) {
    const validation = getValidation(status);
    const { isFocused, focusHandlers } = useFieldFocus(false);

    return (
        <Field id={id} label={label} className={className}>
            {children}
            <FieldValidation
                id={id}
                status={status}
                notices={notices}
                showNotices={isFocused}
            >
                <TextArea
                    {...{
                        id: `field-${id}`,
                        className: `block inset-shadow-sm bg-gray-50 dark:bg-neutral-700 border border:solid border-2 ${validation.borderClasses} rounded w-full dark:text-neutral-200`,
                        onChange:
                            onChange ??
                            ((event) => setValue?.(event.currentTarget.value)),
                        ...focusHandlers,
                        ...rest,
                    }}
                />
            </FieldValidation>
        </Field>
    );
}
